export const rotterdamStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'SportsOrganization',
      '@id': 'https://rotterdam.aguabjj.nl/#organization',
      name: 'Team Agua BJJ Rotterdam',
      url: 'https://rotterdam.aguabjj.nl/',
      logo: 'https://rotterdam.aguabjj.nl/images/team-agua-500.png',
      image: 'https://rotterdam.aguabjj.nl/images/optimized/agua-bjj-rotterdam-group-photo-1280.webp',
      telephone: '+31636137108',
      sport: 'Brazilian Jiu-Jitsu',
      sameAs: [
        'https://www.instagram.com/teamagua.rotterdam/',
        'https://www.facebook.com/TA.bjj',
        'https://youtube.com/@kenanb3328',
        'https://www.linkedin.com/company/agua-bjj-rotterdam/',
      ],
    },
    {
      '@type': 'SportsActivityLocation',
      '@id': 'https://rotterdam.aguabjj.nl/#south',
      name: 'Team Agua BJJ Rotterdam Zuid',
      url: 'https://rotterdam.aguabjj.nl/#location-south',
      parentOrganization: {
        '@id': 'https://rotterdam.aguabjj.nl/#organization',
      },
      image: 'https://rotterdam.aguabjj.nl/images/optimized/agua-bjj-rotterdam-group-photo-1280.webp',
      telephone: '+31636137108',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Tandwielstraat 24',
        postalCode: '3083 AV',
        addressLocality: 'Rotterdam',
        addressCountry: 'NL',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'https://schema.org/Monday',
          opens: '19:30',
          closes: '21:30',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'https://schema.org/Tuesday',
          opens: '20:00',
          closes: '21:30',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'https://schema.org/Thursday',
          opens: '19:30',
          closes: '21:00',
        },
      ],
    },
    {
      '@type': 'SportsActivityLocation',
      '@id': 'https://rotterdam.aguabjj.nl/#center',
      name: 'Team Agua BJJ Rotterdam Centrum',
      url: 'https://rotterdam.aguabjj.nl/#location-center',
      parentOrganization: {
        '@id': 'https://rotterdam.aguabjj.nl/#organization',
      },
      image: 'https://rotterdam.aguabjj.nl/images/optimized/agua-bjj-rotterdam-group-photo-1280.webp',
      telephone: '+31636137108',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Schiedamse Vest 188',
        postalCode: '3011 BH',
        addressLocality: 'Rotterdam',
        addressCountry: 'NL',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'https://schema.org/Wednesday',
          opens: '19:30',
          closes: '21:30',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'https://schema.org/Saturday',
          opens: '13:00',
          closes: '15:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'https://schema.org/Sunday',
          opens: '11:00',
          closes: '13:00',
        },
      ],
    },
  ],
};
